import React from 'react'
import classNames from 'classnames'

import ItemMatrixSelector from './itemMatrixSelector'
import ModalErrorMessage from './modalErrorMessage'
import ItemSummary from './itemSummary'
import LoadItemMatrixError from './loadItemMatrixError'
import UsDollarsNoticeContainer from '../../usDollarsNotice/usDollarsNoticeContainer'

import * as styles from './addEntry.module.css'

export default ({
  item,
  itemMatrix,
  selectedMatrixLicense,
  selectedMatrixSupport,
  onMatrixLicenseChange,
  onMatrixSupportChange,
  loadItemMatrixError,
  modalMessages,
  closeModal,
  onAddToCart,
  onEditCartEntry,
  modalStep,
  isLoading
}) => {
  const modalClassName = classNames('fds-c-modal -width-m modal', {
    'is-disabled-loading': isLoading
  })
  return (
    <div className={modalClassName}>
      <header className="fds-c-modal__header fds-u-text-align-center">
        <h2 className="fds-c-text-heading -size-m fds-u-mb0">
          Customize Your Selection
        </h2>
      </header>
      {itemMatrix && (
        <ItemMatrixSelector
          itemMatrix={itemMatrix}
          selectedMatrixLicense={selectedMatrixLicense}
          selectedMatrixSupport={selectedMatrixSupport}
          onMatrixLicenseChange={onMatrixLicenseChange}
          onMatrixSupportChange={onMatrixSupportChange}
        />
      )}
      {loadItemMatrixError && (
        <LoadItemMatrixError error={loadItemMatrixError} />
      )}
      {modalMessages && <ModalErrorMessage modalMessages={modalMessages} />}
      <ItemSummary
        item={item}
        itemMatrix={itemMatrix}
        selectedMatrixLicense={selectedMatrixLicense}
        selectedMatrixSupport={selectedMatrixSupport}
      />
      <UsDollarsNoticeContainer styleClassName={styles.gstNotice} />
      {!loadItemMatrixError && (
        <footer className="fds-c-modal__footer">
          <div className="fds-c-modal__footer-cta -align-left">
            <button className="fds-c-button -color-light" onClick={closeModal}>
              Cancel
            </button>
          </div>

          <div className="fds-c-modal__footer-cta -align-right">
            {modalStep === 'add' ? (
              <button
                className="fds-c-button--3d -color-primary"
                onClick={onAddToCart}
              >
                Add to Cart
              </button>
            ) : (
              <button
                className="fds-c-button--3d -color-primary"
                onClick={onEditCartEntry}
              >
                Save Selection
              </button>
            )}
          </div>
        </footer>
      )}
    </div>
  )
}
